// extracted by mini-css-extract-plugin
export default {"alert_container":"ez3leNih9qA67U8HAn8G"};